// @flow
import type {Element} from 'react'
import React, {Component} from 'react'

type Props = {
  destroyCircleKeepRole: boolean,
  isReadonly: boolean,
  onChange: Function,
  parentCircleName: string,
  roleName: string,
}

/* eslint jsx-a11y/label-has-for: 0 */

class KeepDeleteSwitch extends Component<Props> {
  updateAbsorbCircle: ((event: any) => void) = (event: Object) => {
    const absorb = event.currentTarget.id === 'absorb-circle'
    this.props.onChange(['destroyCircleKeepRole'], absorb)
  }

  // eslint-disable-next-line react/no-arrow-function-lifecycle
  render: (() => Element<"div">) = () => (
    <div className="circle-footer-keep-delete-switch">
      <label className="circle-footer-keep-delete-switch__toggle" htmlFor="absorb-circle">
        <input
          checked={this.props.destroyCircleKeepRole}
          disabled={this.props.isReadonly}
          id="absorb-circle"
          name="absorb-circle-radio-group"
          onChange={this.updateAbsorbCircle}
          type="radio"
        />
        <b>{I18n.t('proposals.circle_collapse.keep')}</b>
        &nbsp;
        {I18n.t(
          'proposals.circle_collapse.as_role_in_circle',
          {role: this.props.roleName, circle: this.props.parentCircleName},
        )}
      </label>
      <label className="circle-footer-keep-delete-switch__toggle" htmlFor="remove-circle">
        <input
          checked={!this.props.destroyCircleKeepRole}
          disabled={this.props.isReadonly}
          id="remove-circle"
          name="absorb-circle-radio-group"
          onChange={this.updateAbsorbCircle}
          type="radio"
        />
        <b>{I18n.t('proposals.circle_collapse.delete')}</b>
        &nbsp;
        {I18n.t('proposals.circle_collapse.role_entirely', {role: this.props.roleName})}
      </label>
    </div>
  )
}

export default KeepDeleteSwitch
